import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { IN_APP_ROUTES } from "@/constants/urls";
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthGuard() {


    const { isAuthenticated, setIsAuthenticated, profileData: user, isLoadingProfileData: isLoading, isErrorProfileData: isError, isFetchingProfileData } = useAuth()
    const location = useLocation();

    useEffect(() => {
        if (!user || isLoading || isError) return

        if (isAuthenticated && isAuthenticated?.authStatus && isAuthenticated?.status !== user?.status) {
            setIsAuthenticated({
                authStatus: true,
                status: String(user.status).toUpperCase()
            })
        }
    }, [isLoading, isError, user])


    if (isFetchingProfileData) return <div className="flex h-dvh items-center justify-center">
        <Loader2
            className="animate-spin"
            size={20}
            color="blue"
        />
    </div>;

    if (!user || isError) {
        return <Navigate to="/login" replace />;
    }

    const currentPath = location.pathname;

    switch (String(user?.status).toUpperCase()) {
        case "REGISTERED":
            if (currentPath !== IN_APP_ROUTES.OTP_VERIFICATION) {
                return <Navigate to={IN_APP_ROUTES.OTP_VERIFICATION} replace />;
            }
            break;

        case "VERIFIED":
            if (!currentPath.startsWith(IN_APP_ROUTES.PAYMENT)) {
                return <Navigate to={IN_APP_ROUTES.PAYMENT} replace />;
            }
            break;

        case "PAYMENT_DONE":
            if (!currentPath.startsWith(IN_APP_ROUTES.COMPSET_PAGE)) {
                return <Navigate to={IN_APP_ROUTES.COMPSET_PAGE} replace />;
            }
            break;

        case "ACTIVE":
            // If user is fully onboarded,
            // prevent them from going back to onboarding pages
            if (currentPath.startsWith("/setup") || currentPath === IN_APP_ROUTES.OTP_VERIFICATION) {
                return <Navigate to={IN_APP_ROUTES.DASHBOARD} replace />;
            }
            break;
    }

    return <Outlet />;
}